import "./MainBody.scss";
import ButtonRectangle from "../../UIComponents/ButtonRectangle/ButtonRectangle";
const MainBody = () => {
  return (
    <main>
      <div className="u-center-text u-margin-bottom-big" id="mainbody">
        <section className="section-about">
          <h2 className="heading-secondary">
            "Switzerland is not just a country, it’s an attitude of mind."
            <span className="heading-secondary-sub">Yann Martel</span>
          </h2>
          <section>
            <div className="row">
              <div className="col-1-of-2">
                <h3 className="heading-tertiary u-margin-bottom-small">
                  Explore the Majestic Swiss Alps
                </h3>
                <p className="paragraph">
                  Marvel at the awe-inspiring Swiss Alps, a majestic mountain
                  range that stretches across the country. Take in the crisp,
                  fresh air as you ascend to dizzying heights, surrounded by
                  snow-capped peaks, lush meadows, and cascading waterfalls. Ski
                  down world-renowned slopes in winter or hike along panoramic
                  trails in summer, immersing yourself in a pristine alpine
                  wonderland.
                </p>
                <h3 className="heading-tertiary u-margin-bottom-small">
                  Enchanting Lakes and Tranquil Waters
                </h3>
                <p className="paragraph">
                  Switzerland is blessed with shimmering lakes that beckon you
                  to relax and unwind. From the stunning Lake Geneva, nestled
                  between the French Alps and the Jura Mountains, to the
                  mystical Lake Lucerne, framed by towering mountains and
                  historic towns, these pristine bodies of water offer
                  tranquility and beauty. Embark on boat cruises, indulge in
                  water sports, or simply bask in the serenity of these natural
                  gems.
                </p>
                <ButtonRectangle href="#features" text={"find more"} />
              </div>
              <div className="col-1-of-2">
                <div className="composition">
                  <img
                    src="img/swiss-italy-train.ngsversion.1512133001257.adapt.1900.1.jpg"
                    alt="swiss-italy-train"
                    className="composition-photo composition-photo-p1"
                  ></img>
                  <img
                    src="img/lake_constance_switzerland.jpg"
                    alt="lake_constance_switzerland"
                    className="composition-photo composition-photo-p2"
                  ></img>
                  <img
                    src="img/zermatt-matterhorn-switzerland-shutterstock_1298208013_44fea015e5_alps.jpg"
                    alt="ermatt-matterhorn-switzerland-shutterstock"
                    className="composition-photo composition-photo-p3"
                  ></img>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};
export default MainBody;
